<template>
    <div>
        <kgr-loading v-if="loading" />
        <kgr-form-scaffold
            v-else
            :pending="updating"
            :with-back-button="false"
            @primaryBtnClicked="save()"
        >
            <div class="kgr-grid kgr-grid--gutters">
                <div class="kgr-grid__cell">
                    <kgr-text-input
                        v-model="config.hmacKey"
                        :error="error.messageForField('hmacKey')"
                        :label="$t('API-Key für die Vertragsbearbeitung*')"
                    />
                    <kgr-text-input
                        v-model="config.hmacUsername"
                        :error="error.messageForField('hmacUsername')"
                        :label="$t('ISBJ-Benutzername*')"
                    />
                    <kgr-text-input
                        v-model="config.certificatePassword"
                        :error="error.messageForField('certificatePassword')"
                        :label="$t('Zertifikat-Passwort (ISBJ-Kennwort für die Installation)*')"
                    />
                </div>
                <div class="kgr-grid__cell">
                    <div class="kgr-region kgr-region--gray">
                        <kgr-certificate-form
                            :federation-id="federation"
                            :config="config"
                        />
                    </div>
                </div>
            </div>
        </kgr-form-scaffold>
    </div>
</template>

<script>
import CertificateForm from './CertificateForm';
import Error from '../../../js/model/Error';
import FederationIsbjConfig from '../../../js/dto/isbj/FederationIsbjConfig';
import FormScaffold from '../../common/form/FormScaffold';
import IsbjFederationConfigRepository from '../../../js/repository/IsbjFederationConfigRepository';
import Loading from '../../common/Loading';
import TextInput from '../../common/form/input/TextInput';

export default {
    components: {
        'kgr-text-input': TextInput,
        'kgr-loading': Loading,
        'kgr-certificate-form': CertificateForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        federation: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            updating: false,
            config: null,
            error: new Error(),
        };
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            IsbjFederationConfigRepository
                .find(this.federation)
                .then((data) => {
                    this.config = new FederationIsbjConfig(data);
                    this.loading = false;
                });
        },
        save() {
            this.updating = true;

            IsbjFederationConfigRepository
                .update(this.federation, this.config)
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.error = new Error();
                })
                .catch((error) => {
                    this.$notify.error('saveChanges.error');
                    this.error = error;
                })
                .finally(() => this.updating = false);
        },
    },
};
</script>
